import React from "react";
import { Box, Heading, HStack, Text, VStack } from "native-base";
import googlePlayButton from "../../assets/Google Play App Button.png";
import appStoreButton from "../../assets/Apple App Store Button.png";
import { APP_STORE_URL, GOOGLE_PLAY_URL, appVenueLink } from "../../orderingConfig";

/**
 * Shown on the venue page instead of the web cart while web ordering is off.
 */
export function OrderInApp({ venue, docId, tableNo }) {
  const openLink = appVenueLink(venue, docId, tableNo);
  return (
    <section aria-labelledby="order-in-app-title">
      <Box
        bg="coolGray.50"
        borderWidth={1}
        borderColor="coolGray.200"
        borderRadius="lg"
        p={4}
        mb={6}
      >
        <VStack space={2}>
          <Heading size="sm" color="coolGray.800" accessibilityRole="header" aria-level="2" nativeID="order-in-app-title">
            Order through the Piatto app
          </Heading>
          <Text fontSize="sm" color="coolGray.700">
            {`To order from ${venue?.bizName || "this venue"}, use the Piatto app. You can browse the menu here.`}
          </Text>
          {tableNo ? (
            <Text fontSize="sm" color="coolGray.700">
              {`Your table number (${tableNo}) will be filled in when you open this venue in the app.`}
            </Text>
          ) : null}
          <a href={openLink} style={{ fontWeight: 600, color: "#b91c1c" }}>
            {`Open ${venue?.bizName || "this venue"} in the Piatto app`}
          </a>
          <HStack space={3} flexWrap="wrap" mt={1}>
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              <img src={appStoreButton} alt="Download on the App Store" style={{ height: 44 }} />
            </a>
            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
              <img src={googlePlayButton} alt="Get it on Google Play" style={{ height: 44 }} />
            </a>
          </HStack>
        </VStack>
      </Box>
    </section>
  );
}

export default OrderInApp;
